import { render, staticRenderFns } from "./PaginationListOnly.vue?vue&type=template&id=671e76c0&scoped=true"
import script from "./PaginationListOnly.vue?vue&type=script&lang=js"
export * from "./PaginationListOnly.vue?vue&type=script&lang=js"
import style0 from "./PaginationListOnly.vue?vue&type=style&index=0&id=671e76c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671e76c0",
  null
  
)

export default component.exports